import React, {useState, useRef, useEffect} from "react";
import { Route, Routes } from "react-router";
import Main from 'components/Main';
import Me from "components/Me";

import logoSm from "img/logo-sm.svg";

const imagesToPreload = [
  "/img/paper-black.jpg",
  "/img/paper-purple.jpg",
  "/img/projects/soundsunite/thumb.jpg",
  "/img/projects/soundsunite/thumb2.jpg",
  "/img/projects/soundsunite/thumb3.jpg",
  "/img/projects/vari/thumb.jpg",
  "/img/projects/vari/thumb2.jpg",
  "/img/projects/vari/thumb3.jpg",
];

const App = () => {

  const viewportH = window.innerHeight;
  const viewportW = window.innerWidth;
  const appDiv = useRef(null);
  const root = document.documentElement;
  
  const [loaded, setLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const [dimensions, setDimensions] = useState({ 
    height: viewportH,
    width: viewportW
  });
  
  console.log("app refresh", loadedCount);
  
  useEffect(() => {
    
    root.style.setProperty('--real-vh', viewportH + "px");
    
    function handleResize() {
      setDimensions({
        height: viewportH,
        width: viewportW
      });
    }
    
    window.addEventListener('resize', handleResize);

    return _ => {
      window.removeEventListener('resize', handleResize);
    }
    
  });

  useEffect(() => {
    preloadImages(imagesToPreload, setLoadedCount)
      .then(() => setLoaded(true))
      .catch(() => setLoaded(true)); //handle error case maybe
  }, []);
  
  if (!loaded) return (
    <div className="loading-page">
      <img src={logoSm} />
      <div className="progress">
        <div style={{width: `${(loadedCount/imagesToPreload.length)*100}%`}} className="progress-inner" />
      </div>
    </div>
  )
  return (
    <div className="app" ref={appDiv}>
      <Routes>
        <Route exact path="/" element={<Main vH={viewportH} vW={viewportW}/>}/>
        <Route exact path="/work" element={<Main position={"work"} vH={viewportH} vW={viewportW}/>}/>
        <Route path="/me" element={<Me appDiv={appDiv}/>}/>
        <Route exact path="/:project" element={<Main position={"focus"} vH={viewportH} vW={viewportW}/>}/>
      </Routes>
    </div>
  );
}

const preloadImages = (srcArray, setLoadedCount) => {
  return Promise.all(
    srcArray.map((src) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          setLoadedCount(prev => prev + 1);
          resolve();
        };
        img.onerror = reject;
      }))
  );
}

export default App;
